import { render } from "./SideBar.component.vue?vue&type=template&id=78520cf6&ts=true"
import script from "./SideBar.component.vue?vue&type=script&lang=ts"
export * from "./SideBar.component.vue?vue&type=script&lang=ts"

import "./SideBar.component.vue?vue&type=style&index=0&id=78520cf6&lang=css"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__